<app-common-loader />
<router-outlet />
